import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>404: Not Found!</h1>
      <div>
        <p> Uh oh! The content you are looking for could not be found. </p>
      </div>
    </div>
  );
};
export default NotFound;
